import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "syncButton"]
  static values = { url: String }

  async sync() {
    if (this.syncing) return
    this.syncing = true

    const icon = this.syncButtonTarget.querySelector("span:last-child")
    const originalText = icon?.textContent
    if (icon) icon.textContent = "Syncing..."
    this.syncButtonTarget.classList.add("opacity-50")

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const html = await response.text()
        // Remember which tab is active
        const activeTab = this.contentTarget.querySelector('[data-tabs-target="content"]:not(.hidden)')
        const activeValue = activeTab?.dataset?.value

        this.contentTarget.innerHTML = html

        // Restore active tab
        if (activeValue) {
          this.contentTarget.querySelectorAll('[data-tabs-target="content"]').forEach(tab => {
            if (tab.dataset.value === activeValue) {
              tab.classList.remove("hidden")
            } else {
              tab.classList.add("hidden")
            }
          })
        }
      }
    } catch (e) {
      console.error("Sidebar sync failed:", e)
    } finally {
      this.syncing = false
      if (icon) icon.textContent = originalText
      this.syncButtonTarget.classList.remove("opacity-50")
    }
  }
}
